import store from '@/store';

export function widgetIsActive() {
  const widgetSettings =
    store.getters['merchant/getConnectedProviderWithWidgetSettings'];

  return !!Object.keys(widgetSettings || {}).length;
}

export function widgetIsEnabled() {
  const widgetSettings =
    store.getters['merchant/getConnectedProviderWithWidgetSettings'];

  if (Object.keys(widgetSettings || {}).length) {
    return widgetSettings.settings.enabled;
  }

  return false;
}
